import { Stack, Text } from "@mantine/core";
import { ResponsiveLine } from "@nivo/line";
import './styles.scss';

interface Props {
  title: JSX.Element,
  data?: any[],
  marginBottom?: number,
  yFormat?: any,
  curve?: any,
  colors?: any,
  axisLeftName: string,
  axisBottom?: any,
  formatYAxis?: (value: any) => string | number,
  enableGridX?: boolean,
  sliceTooltip?: (props: any) => any,
  legends?: any[],
  toggler?: JSX.Element
}

function WidgetNivoLine(props: Props) {
  const {
    title,
    data,
    marginBottom,
    yFormat,
    curve,
    colors,
    axisLeftName,
    axisBottom,
    formatYAxis,
    enableGridX,
    sliceTooltip,
    legends,
    toggler
  } = props;

  function renderGraph() {
    if (data) {
      return (
        <ResponsiveLine
          data={data}
          margin={{ top: 5, right: 20, bottom: marginBottom, left: 45 }}
          xScale={{ type: 'point' }}
          curve={curve}
          colors={colors ? colors : "#6CADD9"}
          yScale={{
            type: 'linear',
            min: 0,
            max: 'auto'
          }}
          yFormat={yFormat}
          axisTop={null}
          axisRight={null}
          axisBottom={axisBottom}
          axisLeft={{
            format: formatYAxis,
            tickSize: 3,
            tickPadding: 3,
            tickRotation: 0,
            legend: axisLeftName,
            legendPosition: 'middle',
            legendOffset: -40
          }}
          pointSize={4}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={1.5}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabelYOffset={-12}
          enableGridX={enableGridX}
          enableArea={true}
          useMesh={true}
          enableSlices="x"
          legends={legends}
          sliceTooltip={sliceTooltip}
        />
      )
    } else {
      return (
        <Stack align="center">
          <Text>No Data Found</Text>
        </Stack>
      )
    }
  }

  return (
    <div className="widget-nivo-base">
      <div className="header">
        {title}
        {toggler}
      </div>
      <div className="widget-chart-container">
        {renderGraph()}
      </div>
    </div>
  )
}

export default WidgetNivoLine;
